<section class="story">
        <div class="rs-container story__inner" [rsReveal]="0">
        <div class="story__media">
            <div class="story__media__plate"></div>
            <img class="story__media__cutout"
                 src="assets/img/home/familie-rettensteiner-scharfetter.png"
                 alt="Familie Rettensteiner-Scharfetter">
        </div>

        <div class="story__body" [rsReveal]="120">
            <p class="rs-eyebrow">Unsere Familie</p>
            <h2 class="story__title">Für uns ist Fleisch kein billiger Sattmacher.</h2>
            <p class="story__text">
                Sondern ein wertvoller Bestandteil einer ausgewogenen Ernährung. Natürliches Fleisch,
                Herkunft und Qualität – genau das gibt bei uns den Ton an.
            </p>
            <p class="story__text">
                Wir schlachten selbst, verarbeiten selbst und kennen die Höfe, von denen unsere Tiere kommen.
                Das schmeckt man – in der Theke genauso wie am Teller in der Marktstubn.
            </p>

            <ul class="story__facts">
                <li><span>01</span>Rindfleisch aus hauseigener Schlachterei</li>
                <li><span>02</span>Zertifizierter Betrieb der Genussregion Pongauer Wild</li>
                <li><span>03</span>Hausgemachte Wurst- und Speckspezialitäten</li>
                <li><span>04</span>Frischer Mittagstisch, Frühstück &amp; Feinkost</li>
            </ul>

            <a class="rs-btn rs-btn--primary" routerLink="/qualität">Mehr über unsere Qualität</a>
        </div>
    </div>
</section>
